import React from "react";

export default function MasteredIcon(props) {
  return <span className="glyphicon glyphicon-ok marked-as-known-count-icon" style={Object.assign({ color: "#5cb85c" }, props.style)}></span>;
}
